export const _mapResourceToAppType = (resource) => {
    return {
        id: resource.resource_id,
        name: resource.resource_name,
        description: resource.resource_description,
        url: resource.resource_link,
        type: resource.resource_type,
    };
};